import { Box } from "@mui/material";
import { VideoSectionCarousel } from "./VideoSectionCarousel";
import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../context/UserContext";
import { BrowseVideoSection, SectionItemsEntity, UserCtx } from "../../../interfaces";
import { SkeletonLoader } from "./SkeletonLoader";

export const BrowseVideoContainer = () => {
  const [browseSections, setBrowseSections] = useState<BrowseVideoSection[]>([]);
  const userCtx = useContext(UserContext) as UserCtx;
  const [isPageLoading, setPageLoading] = useState(true);
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    const GetSkillDetails = async (skillIds: string[]) => {
      try {
        let skillDetails = await userCtx.getSkillDetailsBySkillIds(skillIds);
        return skillDetails.slice(0, 10);
      } catch (e) {
        console.log("Error getting skill details: ", e);
        throw e;
      }
    };
    const GetBrowseSectionData = async () => {
      let browseSections = await userCtx.getBrowseSkillSections();
      let s = await browseSections.reduce(
        async (acc: Promise<BrowseVideoSection[]>, curr: BrowseVideoSection) => {
          if (curr.sectionType === "single" && curr.isAdditionalDataRequired) {
            let skillIds = curr.sectionItems.map(
              (item: SectionItemsEntity) => item.skill_id
            );
            let skillDetails = await GetSkillDetails(skillIds as string[]);
            (await acc).push({
              sectionTitle: curr.sectionTitle,
              sectionItems: skillDetails,
              sectionType: curr.sectionType,
              isAdditionalDataRequired: curr.isAdditionalDataRequired,
            });
          } else {
            (await acc).push(curr);
          }
          return acc;
        },
        Promise.resolve([])
      );

      setBrowseSections(s);
      setPageLoading(false);
      userCtx.setRefreshExplorePageData(false);
    };
    if (!dataLoaded) {
      GetBrowseSectionData().catch((e) => {
        console.error("Error getting browse section data: ", e);
      });
      setDataLoaded(true);
    }
  }, [userCtx.refreshExplorePageData, userCtx, dataLoaded]);
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "22px",
          marginTop: "32px",
          marginBottom: "40px",
        }}>
        {isPageLoading ? (
          <SkeletonLoader loaderType={"explore"} />
        ) : (
          browseSections.map((section, i) => {
            return (
              <VideoSectionCarousel
                key={i}
                videoList={section.sectionItems}
                videoSectionTitle={section.sectionTitle}
                CarouselType={section.sectionType === "group" ? "group" : "single"}
              />
            );
          })
        )}
      </Box>
    </>
  );
};
